import { ReviewsServiceName } from "@bluframe/mightychroma-mightytool-frontend-types"
import CardActionButton from "components/Cards/Card/Actions/Button"
import Reviews from "components/HomeVideoReviews/Reviews"

import { ComponentProps } from "."
import Actions from "./Actions"
import { Buttons, Row, Wrapper } from "./styled"

export interface ServiceRow {
  serviceName: ReviewsServiceName
  name: string
}

export interface ServiceSection {
  id: string
  rows: ServiceRow[]
}

const Main = ({
  actionsPropsByService,
  clearAllListsButtonProps,
  isAdmin,
  isEditor,
  listAllButtonProps,
  reviewsPropsByService,
  services
}: ComponentProps) => (
  <Wrapper>
    <Buttons>
      <CardActionButton {...listAllButtonProps} />

      <CardActionButton {...clearAllListsButtonProps} />
    </Buttons>

    {services.map((section) => (
      <Row key={section.id}>
        {section.rows.map((row) => {
          const actionsProps = actionsPropsByService[row.serviceName]
          const reviewsProps = reviewsPropsByService[row.serviceName]

          return (
            <Reviews
              {...reviewsProps}
              actions={
                <Actions
                  {...actionsProps}
                  isAdmin={isAdmin}
                  isEditor={isEditor}
                />
              }
              key={`${section.id}-${row.serviceName}`}
            />
          )
        })}
      </Row>
    ))}
  </Wrapper>
)

Main.whyDidYouRender = true

export default Main
